import { createTabSlice } from './createTabSlice'

const steps = ["orders", "invoice", "return", "newOrder", "preparing", "ready", 
	// "delivered"
] as const;
// const steps = ["newOrder", "preparing", "ready", "delivered"] as const;

type tabStep = (typeof steps)[number];

const slice = createTabSlice({
	name: "tab",
	steps,
});

export const { setActiveKey } = slice.actions;
export default slice.reducer;
export type { tabStep }